<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" type="primary" @click="handleAdd" icon="el-icon-plus" plain>
                        新增积分优惠券
                    </el-button>
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete" plain>
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button size="mini" type="text" @click="handleView(scope.row)" icon="el-icon-view">
                        查看
                    </el-button>
                    <el-button size="mini" type="text" @click="handleEdit(scope.row, scope.$index)" icon="el-icon-edit">
                        编辑
                    </el-button>
                    <el-button size="mini" type="text" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                    <el-button size="mini" type="text" @click="openUpload(scope.row)" icon="el-icon-upload">
                        导入
                    </el-button>
                    <el-button size="mini" type="text" @click="sendRecord(scope.row.id)" icon="el-icon-view">
                        发放记录
                    </el-button>
                    <el-button size="mini" type="text" @click="handleSend(scope.row)" icon="el-icon-circle-plus">
                        发放
                    </el-button>
                </template>
            </avue-crud>
            <el-dialog title="新增积分优惠券" :visible.sync="dialogVisible" width="70%">
                <el-form :model="form" label-width="120px" :rules="rules" ref="form">
                    <el-form-item label="积分优惠券名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入积分优惠券名称" />
                    </el-form-item>
                    <el-form-item label="指定产品" prop="goodsList">
                        <el-button type="text" @click="isSelectorVisible = true" icon="el-icon-plus">选择产品</el-button>
                        <el-table :data="form.goodsList" style="width: 100%" :border="true"
                            v-if="form.goodsList.length">
                            <el-table-column label="产品名称" prop="name"></el-table-column>
                            <!-- <el-table-column label="抵扣积分">
                                <template slot-scope="scope">
                                    {{ scope.row.points }}
                                </template>
                            </el-table-column> -->
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="handleDeleteProduct(scope.$index)"
                                        icon="el-icon-delete">
                                        删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <product-selector :visible.sync="isSelectorVisible" @confirm="handleProductSelection" />
                    </el-form-item>
                    <el-form-item label="优惠券有效期" prop="endDate">
                        <el-col :span="11">
                            <el-date-picker v-model="form.startDate" type="datetime" placeholder="开始日期"
                                value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                        </el-col>
                        <el-col class="line" :span="2">~</el-col>
                        <el-col :span="11">
                            <el-date-picker v-model="form.endDate" type="datetime" placeholder="结束日期"
                                value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="使用说明" prop="remarks">
                        <el-input type="textarea" v-model="form.remarks" placeholder="请输入内容" rows="4" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSubmit">保存</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="dialogVisibleTitle" :visible.sync="sendDialogVisible" width="30%"
                :close-on-click-modal="false">
                <el-select v-model="engineer.engineerName" placeholder="请选择工程师" filterable remote
                    :remote-method="handleRemote" clearable @change="handleEngineerChange">
                    <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id"></el-option>
                </el-select>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSendSubmit">发放</el-button>
                    <el-button @click="sendDialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="批量积分导入" :visible.sync="openUploadDialogVisible" width="70%" :close-on-click-modal="false">
                <el-upload class="upload-demo" ref="upload" :action="fileUrl" :limit="1" :headers="headers"
                    accept=".xls,.xlsx,csv" :on-remove="handleRemoveFile" :file-list="fileList" :auto-upload="false"
                    :on-change="handleFileChange">
                    <el-button type="success" size="small" round>导入Excel<i
                            class="el-icon-upload el-icon--right"></i></el-button>
                    <div slot="tip" class="el-upload__tip">只能上传xls/xlsx/csv文件</div>
                </el-upload>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleUpload">上传</el-button>
                    <el-button @click="cancelUpload">取消</el-button>
                </div>
            </el-dialog>
            <send-record :visibleRecord.sync="sendRecordVisible" :couponId="couponId" />
        </basic-container>
    </div>
</template>
<script>
import { couponOption } from "@/const/salesCloud/couponOption";
import {
    getCouponList,
    getCouponDetail,
    addOrEditCoupon,
    delCoupon,
    sendCoupon,
    oneClickGrant,
    downloadXls,
    findUserList
} from "@/api/salesCloud/coupon";
import { findIntegralgoodsByRootDepartId } from "@/api/salesCloud/integralgoods";
import ProductSelector from "./components/productSelector/index.vue";
import EngineerSelector from "./components/engineerSelector/index.vue";
import SendRecord from "./components/sendRecord/index.vue";
export default {
    name: "coupon",
    components: {
        ProductSelector,
        EngineerSelector,
        SendRecord
    },
    data() {
        return {
            tableOption: couponOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            dialogVisible: false, // 控制弹窗显示
            dialogVisibleTitle: "", // 弹窗标题
            form: {
                name: "", // 优惠券名称
                goodsList: [], // 可用产品（仅在选择"产品"时使用）
                type: "", // 优惠券类型，默认值为优惠券
                startDate: "", // 优惠券有效期开始时间
                endDate: "", // 优惠券有效期结束时间
                prompt: "", // 提示语
                remarks: "", // 使用说明
            },
            users: [],
            engineer: {
                engineerId: "",
                engineerMobile: "",
                engineerName: "",
            },
            goodsViewList: [], // 查看产品列表
            allGoodsList: [], // 所有商品列表
            dialogVisibleGoods: false, // 查看产品弹窗
            isSelectorVisible: false,
            sendDialogVisible: false, // 发放优惠券弹窗
            sendDialogVisibleChild: false, // 选择工程师弹窗
            sendRecordVisible: false, // 发放记录弹窗
            openUploadDialogVisible: false,
            fileList: [],
            fileUrl: "https://huijia.joinstech.com", //上传文件的域名地址
            headers: {
                "Content-Type": "multipart/form-data",
            },
            couponId: "", // 优惠券id
            sendForm: [],
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            // 表单验证规则
            rules: {
                name: [
                    { required: true, message: "请输入优惠券名称", trigger: "blur" },
                ],
                endDate: [
                    { required: true, message: "请选择优惠券有效期", trigger: "change" },
                ],
                goodsList: [
                    {
                        required: true,
                        message: "请选择指定产品",
                        trigger: "change",
                        validator: (rule, value, callback) => {
                            if (!value || !value.length) {
                                callback(new Error("产品不能为空"));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                remarks: [
                    { required: true, message: "请输入优惠券使用说明", trigger: "blur" }
                ],
            },
        };
    },
    created() {
        this.handleList();
    },
    mounted() { },
    computed: {
    },
    watch: {
    },
    props: [],
    methods: {
                /**
         * 
         * @param query 
         * @description 远程搜索工程师
         */
         handleRemote(query) {
            // eslint-disable-next-line no-control-regex
            if (/[^\x00-\xff]/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            } else if (/^\d{8,}$/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            }
        },
        handleEngineerChange(val) {
            if (this.users.length > 0) {
                this.user = this.users.find((item) => item.id == val);
                this.engineer = {
                    engineerId: this.user.id,
                    engineerMobile: this.user.mobile,
                    engineerName: this.user.realName,
                }
            }

        },
        handleFileChange(file, fileList) {
            this.fileList = fileList;
        },
        cancelUpload() {
            this.openUploadDialogVisible = false;
            this.fileList = [];
            this.couponId = "";
        },
        openUpload(row) {
            this.openUploadDialogVisible = true;
            this.couponId = row.id;
        },
        handleRemoveFile(file) {
            this.fileList = this.fileList.filter(item => item.uid !== file.uid);
        },
        handleUpload() {

            // 校验文件是否存在
            if (!this.$refs.upload.uploadFiles) {
                this.$message.error('请选择文件');
                return;
            }
            const clientType = "JOINS_ENGINEER"
            this.uploadFile(this.$refs.upload.uploadFiles[0].raw, clientType);

        },
        //覆盖默认的上传行为,可以自定义上传的实现
        uploadFile(file, clientType) {
            let formData = new FormData();
            formData.append('file', file);
            formData.append('file_name', file.name);
            formData.append('clientType', clientType);
            downloadXls(formData, this.couponId).then((response) => {

                // 提取文件名
                const filename = "积分优惠券发放.xlsx"
                // 将二进制流转为blob
                const blob = new Blob([response.data], { type: 'application/octet-stream' })
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename))
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob)
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement('a')
                    tempLink.style.display = 'none'
                    tempLink.href = blobURL
                    tempLink.setAttribute('download', decodeURI(filename))
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank')
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink)
                    tempLink.click()
                    document.body.removeChild(tempLink)
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL)
                    this.couponId = "";
                    this.fileList = [];
                    this.openUploadDialogVisible = false;
                    this.handleList();
                }
            });
        },
        sendRecord(id) {
            this.couponId = id;
            this.sendRecordVisible = true;
        },
        closeSendRecordDialog() {
            this.sendRecordVisible = false;
        },
        handleViewGoods(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findIntegralgoodsByRootDepartId(data.goodsList);
                this.dialogVisibleGoods = true;
            });
            this.dialogVisibleGoods = true;
        },
        closeDialogGoods() {
            this.dialogVisibleGoods = false;
        },
        handleTypeChange() {
            // 根据选择的类型重置产品列表和抵扣积分
            if (this.form.type === 0) {
                this.form.goodsList = []; // 清空产品列表
                this.form.minPoints = 0; // 全额抵扣，不需要输入抵扣积分
            } else if (this.form.type === 1) {
                this.form.minPoints = 1; // 默认值
            }
        },
        handleUseRangeChange() {
            // 处理使用范围变化的逻辑
        },
        handleDeleteMerchant(index) {
            this.sendForm.engineer.splice(index, 1);
        },
        handleShopSelection(selectedShops) {
            if (this.sendForm.engineer.length > 0) {
                this.sendForm.engineer = this.sendForm.engineer.concat(selectedShops.filter(item => {
                    return !this.sendForm.engineer.some(engineer => engineer.id === item.id);
                }));
            } else {
                this.sendForm.engineer = selectedShops;
            }
        },
        handleDeleteProduct(index) {
            this.form.goodsList.splice(index, 1);
        },
        handleProductSelection(selectedProducts) {
            // 在此处处理选中的产品数据
            if (this.form.goodsList.length > 0) {
                // 合并数组,已经选择的不添加
                this.form.goodsList = this.form.goodsList.concat(selectedProducts.filter(item => {
                    return!this.form.goodsList.some(goods => goods.goodsId == item.goodsId);
                }));
            } else {
                this.form.goodsList = selectedProducts;
            }
        },
        handleSendSubmit() {
            let params = {
                ids: [this.engineer.engineerId],
                couponId: this.couponId,
            };
            sendCoupon(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "发放成功",
                        type: "success"
                    });
                    this.sendDialogVisible = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : '发放失败,请重试',
                        type: "error"
                    });
                }
            });
        },
        handleisSelectorVisible(val) {
            this.isSelectorVisible = val;
        },
        handleSend(row) {
            this.engineer=[], // 选择的工程师
            this.couponId=row.id, // 选择的优惠券
            this.dialogVisibleTitle = "发放优惠券",
            this.sendDialogVisible = true;
            this.sendDialogVisible = true;
        },
        oneClickGrant(id) {
            oneClickGrant(id).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "发放成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : '发放失败,请重试',
                        type: "error"
                    });
                }
            });
        },
        handleSubmit() {
            
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const params = {
                        ...this.form,
                        name: this.form.name,
                        type: 1,
                        useType: 1,
                        startDate: this.form.startDate,
                        endDate: this.form.endDate,
                        goodsList: this.form.goodsList,
                        remarks: this.form.remarks,
                        prompt: this.form.prompt? this.form.prompt : '',
                    };

                    // 提交逻辑
                    addOrEditCoupon(params, this.dialogVisibleTitle === "编辑优惠券").then(res => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success"
                            });
                            this.handleList();
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message ? res.message : '操作失败,请重试',
                                type: "error"
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        handleAdd() {
            this.clean();
            this.dialogVisible = true;
            this.dialogVisibleTitle = "新增积分优惠券";
        },
        handleEdit(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findIntegralgoodsByRootDepartId(data.goodsList);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "编辑优惠券";
                this.form = {
                    ...data,
                    id: row.id ? row.id : '', // 优惠券id
                    name: row.name, // 优惠券名称
                    type: row.type, // 优惠券类型，默认值为优惠券
                    minPoints: row.minPoints, // 抵扣积分
                    goodsList: this.form.goodsList, // 可用产品（仅在选择"产品"时使用）
                    remarks: row.remarks, // 使用说明
                };
            });
        },
        // 获取商品列表
        findIntegralgoodsByRootDepartId(selectedGoods) {
            const params = {
                page: 1,
                size: 10000,
            }
            findIntegralgoodsByRootDepartId(params).then(res => {
                if (res.code === "200") {
                    let data = JSON.parse(res.data).rows;
                    console.log(data,'data');
                    if (data) {
                        this.allGoodsList = data;
                        // 初始化已选择的商品
                        this.form.goodsList = selectedGoods.map(item => ({
                            ...item,
                            goodsId: item.goodsId,
                            name: this.allGoodsList.find(g => g.id == item.goodsId) ? this.allGoodsList.find(g => g.id == item.goodsId).name : ""
                        }));
                        this.goodsViewList = this.form.goodsList;
                    } else {
                        this.allGoodsList = [];
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        handleView(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findIntegralgoodsByRootDepartId(data.goodsList);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "查看优惠券";
                this.form = {
                    ...data,
                    id: row.id ? row.id : '', // 优惠券id
                    name: row.name, // 优惠券名称
                    type: row.type, // 优惠券类型，默认值为优惠券
                    minPoints: row.minPoints, // 抵扣积分
                    goodsList: this.form.goodsList, // 可用产品（仅在选择"产品"时使用）
                    remarks: row.remarks, // 使用说明
                };
            });
        },
        clean() {
            this.form = {
                goodsList: [], // 可用产品（仅在选择"产品"时使用）
                remarks: "", // 使用说明
            };
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getCouponList(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
            // this.getDepartment();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.blockBox {
    display: flex;
    align-items: center;

    span {
        margin-left: 10px;
    }
}

.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.line {
    text-align: center;
    line-height: 32px;
}

::v-deep .el-form-item__label {
    color: #606266 !important;
    font-weight: 700 !important;
}
</style>